import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Cloud & DevOps Engineer",
          "AWS FinOps Specialist",
          "Cloud Cost Optimization Engineer",
          "CI/CD & DevSecOps Automation",
          "Terraform · Docker · Kubernetes",
          "AWS · Azure Infrastructure Engineer",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 40,
      }}
    />
  );
}

export default Type;
